import React, { useMemo } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./calendar.css";

import es from "date-fns/locale/es"; // ✅ español
registerLocale("es", es);

// yyyy-mm-dd desde Date
const dateToISO = (date) => {
  if (!date) return "";
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// dd-mm-yy -> yyyy-mm-dd
const ddmmyyToISO = (s) => {
  if (!s) return "";
  const [dd, mm, yy] = String(s).split("-");
  if (!dd || !mm || !yy) return "";
  const yyyy = yy.length === 2 ? `20${yy}` : yy;
  return `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
};

const Calendar = ({ selectedDateObj, onChangeDate, forms = [], maxDate = new Date() }) => {
  const daysWithForms = useMemo(() => {
    const set = new Set();
    (Array.isArray(forms) ? forms : []).forEach((f) => {
      const isoFromFecha =
        f?.fecha?.includes("-") && f.fecha.length === 10
          ? f.fecha
          : ddmmyyToISO(f?.fecha);
      const isoFromCreated = f?.createdAt ? String(f.createdAt).slice(0, 10) : "";
      const iso = isoFromFecha || isoFromCreated;
      if (iso) set.add(iso);
    });
    return set;
  }, [forms]);

  return (
    <div className="qs-cal">
      <DatePicker
        inline
        locale="es"                 // ✅ español
        selected={selectedDateObj}
        onChange={(date) => onChangeDate(date)}
        maxDate={maxDate}
        calendarStartDay={1}        // ✅ semana inicia lunes
        calendarClassName="qs-cal-calendar"
        dayClassName={(date) => {
          const iso = dateToISO(date);
          return daysWithForms.has(iso) ? "qs-cal-day qs-cal-has" : "qs-cal-day";
        }}
      />

      <div className="qs-cal-legend">
        <span className="qs-cal-dot qs-cal-dot-has" /> Con formularios
        <span className="qs-cal-dot qs-cal-dot-empty ms-3" /> Sin formularios
      </div>
    </div>
  );
};

export default Calendar;